<template>
  <div class="box">
    <div class="search-box">
      <div :style="{border: `1px solid ${color}`}" class="search-input">
        <input :placeholder="$t('message.tpl1.daily.tip')" ref="input" @keyup.enter="search" v-model="searchText" type="text">
      </div>
      <div style="width: 20px;"></div>
      <div v-touch-ripple @click="search" :style="{backgroundColor: color,color:'#ffffff',cursor: 'pointer',padding: '0 3px'}"
           class="search">
        <img style="vertical-align: middle;width: 16px;" src="./search.png" alt="">
        {{$t("message.search")}}
      </div>
    </div>
    <ul style="margin-top: 20px;">
      <li :key="i" v-if="dayliData" v-for="(item,i) in dayliData" class="daily-item">
        <div class="title" :style="{background: color}">
          <span>{{item.date}}</span><span>{{item.name}}</span>
        </div>
        <div class="table">
          <div class="table-head">
            <div style="width: 136px;">
              {{ $t("message.tpl1.daily.time") }}
            </div>
            <div style="width: 411px">
              {{ $t("message.tpl1.daily.theme") }}
            </div>
            <div style="width: 207px;">{{ $t("message.tpl1.daily.speakerType") }}</div>
            <div style="width: 208px;">{{ $t("message.tpl1.daily.teacher") }}</div>
          </div>
          <div class="table-body" v-for="(cal,j) in item.calendars" :key="j">
            <div style="width: 134px;position: relative;word-break: break-all;" :style="{borderRightColor: color}">
              <span v-html="cal.calStart"></span> - <span v-html="cal.calEnd"></span>
              <b :style="{borderLeftColor: color}" class="s1"></b>
              <b class="s1 s2"></b>
            </div>
            <div style="width: 411px;text-align: left;position: relative;padding-left: 25px;word-break: break-all;">
              <span v-html="cal.calTitle"></span>
              <b class="tip-icon"></b>
            </div>
            <div style="width: 207px;word-break: break-all;">
              <span v-html="cal.calType"></span>
            </div>
            <div style="width: 208px;word-break: break-all;">
              <!-- <span v-if="cal.calHost" v-html="cal.calHost"></span> -->
              <span v-if="cal.hosts.length>0" v-for="(hosts,h) in cal.hosts" :key="h">
                {{hosts.uName}}
              </span>
              <span else-if="cal.speakers.length>0" v-for="(speaker,h) in cal.speakers" :key="h">
                {{speaker.uName}}
              </span>
              <!-- <span else-if="cal.calSpeaker" v-html="cal.calSpeaker"></span> -->
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
  export default{
    data(){
      return {
        searchText: '',
        alldayliData: '',
        searchIndexArr: [],
        dayliData: ''
      }
    },
    props: {
      color: {
        type: String,
        default: () => {
          return '#f39800'
        }
      },
      propData: {
        required: true
      }
    },
    filters: {
      filterText(text){
        if (myvue.searchText.trim().length == 0) {
          return text;
        } else {
//          text.split('')
          if (text.indexOf(myvue.searchText) !== -1) {
              let resultTest = text.replace(myvue.searchText,`<span style="color: ${myvue.color}">${myvue.searchText}</span>`)
            return resultTest;
          } else {
            return text;
          }

        }
      }
    },
    methods: {
        isString(str){
          return (typeof str === 'string' && str.constructor === String);
        },
      filterText(text){
        if (this.searchText.trim(text).length == 0) {
          return text;
        } else {
//          text.split('')
          if(this.isString(text)){
            if (text.indexOf(this.searchText) !== -1) {
              let resultTest = text.replace(this.searchText,`<span style="color: ${this.color}">${this.searchText}</span>`)
              return resultTest;
            } else {
              return text;
            }
          }else{
              return text;
          }
        }
      },
      searchBtn(){
          this.$refs['input'].focus();
      },
//        查询操作
      search(){
        console.log('--------------')
        let results = []; //标记搜索的日程索引
//        获得所有的相关的类型
        let allText = [];
        this.alldayliData.map((item, i) => {
          let tempArr = [];
          tempArr.push(item.name);
          item.calendars.map((cal, j) => {
            let text = `${cal.calStart},${cal.calEnd},${cal.calHost},${cal.calRoom},${cal.calTitle},${cal.calType},${cal.calSpeaker}`;
            tempArr.push(text);
          });
          allText.push(tempArr);
        });
        allText.map((item, i) => {
          if (this.searchText.trim().length > 0) {
//   如果输入查询字符串
            if (item.join('').indexOf(this.searchText) !== -1) {
//                  如果有查询到数据，保存数据索引
              results.push(i);
            }
          } else {
//             如果没有输入查询
            results.push(i);
          }
        });
        this.searchIndexArr = results;
        this.dayliDatafn();
      },
      alldayliDatafunc(){
        let results = [];
        let data = JSON.parse(JSON.stringify(this.propData));
        data.map((item, i) => {
          item.rooms.map((room, k) => {
            room.calendars.map((cal, j) => {
              room.date = item.date;
              cal.subCals.map((subcal, q) => {
                subcal.date = subcal.calSession;
                subcal.name = subcal.calRoom;
                room.calendars.push(subcal);
              })
            });
            results.push(room);
          })
        })
        return results;
      },
      dayliDatafn(){
        let arr = [];
//        因为是对象引用，所以当改变原始对象的时候，会导致保存状态；所以这里复制当前对象，不对原始对象做操作
        let newObj = JSON.parse(JSON.stringify(this.alldayliData));
        this.searchIndexArr.map((item, i) => {
          arr.push(newObj[item])
        });
        arr.map((item,i)=>{
          console.log(item);
          item.calendars.map((cal,j)=>{
            console.log(cal)
            for(var calKey in cal){
              console.log(calKey);
              cal[calKey] = this.filterText(cal[calKey]);
            }
          })
        });
        this.dayliData =  arr;
      }
    },
    computed: {

    },
    mounted(){
      this.alldayliData = this.alldayliDatafunc();
      this.dayliDatafn();
//      显示所有的数据
      this.search();
      window.myvue = this;
      this.$nextTick(() => {
        window.scrollTo(0, 500)
      })
    }
  }
</script>
<style lang="less" scoped>
  .box {
    width: 940px;
    max-width: 100%;
    padding: 5px;
    margin: 40px auto 0;
    .search-box {
      display: table;
      & > div {
        display: table-cell;
      }
      .search-input {
        width: 934px;
        background-color: #ffffff;
        input {
          border: 0;
          box-sizing: border-box;
          width: 100%;
          height: 100%;
          padding-left: 12px;
        }
      }
      .search {
        margin-left: 12px;
        width: 99px;
        line-height: 38px;
        text-align: center;
        font-size: 14px;
      }
    }
    .title {
      min-width: 248px;
      line-height: 20px;
      padding: 8px 12px;
      box-sizing: border-box;
      border-top-right-radius: 4px;
      border-top-left-radius: 4px;
      display: table;
      color: #ffffff;
      font-size: 15px;
      & > span {
        display: table-cell;
        width: 50%;
        text-align: center;
      }
    }
  }

  .daily-item {
    margin-bottom: 18px;
  }

  .table {
    border: 2px solid #999999;
    .table-head{
      border-bottom: 1px solid #aeaeae;
    }
    .table-head, .table-body {
      display: table;
      background-color: #f5f5f5;
      color: #000000;
      line-height: 33px;
      font-size: 15px;
      & > div {

        display: table-cell;
        text-align: center;
        border-right: 1px solid #eaeaea;
      }
    }
    .table-body {
      background-color: #ffffff;
      border-bottom: 1px solid #f5f5f5;
      line-height: 1.2;
      & > div {
        font-size: 13px;
        padding: 12px 8px;
      }
    }
  }
  .tip-icon{
    position: absolute;
    left: 8px;
    top: 18px;
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: #B5B5B5;
  }
  .s1{
    display: inline-block;
    border: 6px solid red;
    right: -12px;
    position: absolute;
    top: 15px;
    border-right-color: transparent;
    border-top-color: transparent;
    border-bottom-color: transparent;
  }
  .s2{
    border-left-color: #ffffff;
    right: -10px;
  }
</style>



// WEBPACK FOOTER //
// dailySearch.vue?0fceb648